import Route from '@ember/routing/route';

export default class AuthenticatedReimaginedLpnRoute extends Route {}
